import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ProductCarousel } from './ProductCarousel';
import { ProductDetailModal } from './ProductDetailModal';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const fetcher = (endpoint) => axios.get(`${API}${endpoint}`, { timeout: 8000 }).then((r) => r.data || []);

/**
 * Homepage section: latest products sorted by id desc.
 */
export const NewArrivalsSection = ({ onAddToCart, onAddToWishlist }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetcher('/products/new-arrivals?limit=12')
      .then((d) => { if (!cancelled) { setProducts(d); setLoading(false); } })
      .catch(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <ProductCarousel
        title="New Arrivals"
        subtitle="Just In"
        products={products}
        loading={loading}
        onProductClick={(p) => setSelected(p)}
        onAddToCart={onAddToCart}
        onAddToWishlist={onAddToWishlist}
        testId="new-arrivals-carousel"
      />
      <ProductDetailModal
        product={selected}
        isOpen={!!selected}
        onClose={() => setSelected(null)}
        onAddToCart={onAddToCart}
        onAddToWishlist={onAddToWishlist}
      />
    </>
  );
};

/**
 * Homepage section: best sellers (paid orders → top-viewed fallback).
 */
export const BestSellersSection = ({ onAddToCart, onAddToWishlist }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetcher('/products/best-sellers?limit=12')
      .then((d) => { if (!cancelled) { setProducts(d); setLoading(false); } })
      .catch(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="bg-[#FAF6EE]" data-testid="best-sellers-section">
      <ProductCarousel
        title="Best Sellers"
        subtitle="Customer Favourites"
        products={products}
        loading={loading}
        onProductClick={(p) => setSelected(p)}
        onAddToCart={onAddToCart}
        onAddToWishlist={onAddToWishlist}
        testId="best-sellers-carousel"
      />
      <ProductDetailModal
        product={selected}
        isOpen={!!selected}
        onClose={() => setSelected(null)}
        onAddToCart={onAddToCart}
        onAddToWishlist={onAddToWishlist}
      />
    </section>
  );
};
